import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import useScrollTo from 'hooks/useScrollTo';

import Rating from 'redesignedComponents/sections/Rating/Rating';
import BannerContainer from 'components/Banner/BannerContainer';

import {
  TemplateCategoryBanner,
  TemplatesBottomInformation,
  TemplatesCategoryGrid,
  TemplateTopNavigation,
  TemplateFilters,
} from 'templates/components';

import { useCategory } from 'templates/hooks';
import { categoryBannerImage, ratingValue, categories } from './constants';
import useStyles from './styles';

const TemplateCategories = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { isSearchPageQueryExists } = useCategory();

  const [searchParams] = useSearchParams();
  const scrollTo = useScrollTo();
  const page = searchParams.get('page') || 1;

  useEffect(() => {
    if (isSearchPageQueryExists) {
      navigate('/templates');
      return;
    }

    scrollTo();
  }, [isSearchPageQueryExists, navigate, page, scrollTo]);

  return (
    <div data-testid={categories} className={classes.root} data-pulse-section-group={categories}>
      <BannerContainer backgroundImage={categoryBannerImage}>
        <TemplateTopNavigation />
        <TemplateCategoryBanner />
      </BannerContainer>
      <TemplateFilters />
      <div className={classes.wrapper}>
        <TemplatesCategoryGrid />
        <TemplatesBottomInformation />
        <Rating ratingValue={ratingValue} ratingCount="6,942" />
      </div>
    </div>
  );
};

export default TemplateCategories;
